import { useState, ChangeEvent } from "react";

type Props = {
  onValidate?: (value: string) => boolean;
  onSuccess?: () => void;
};

const useInput = ({ onValidate, onSuccess }: Props) => {
  const [currentValue, setCurrentValue] = useState("");
  const [hasError, setHasError] = useState(false);
  const [valueIsValid, setValueIsValid] = useState(false);

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim().replaceAll(" ", "");
    setCurrentValue(value);
    setHasError(false);
  };

  const onEnterHandler = () => {
    const isValid = onValidate ? onValidate(currentValue) : true;
    if (!isValid) {
      setHasError(true);
      setValueIsValid(false);
      setCurrentValue("");
      return false;
    }

    setHasError(false);
    setValueIsValid(true);

    if (onSuccess) onSuccess();
    return true;
  };

  const inputReset = () => {
    setCurrentValue("");
    setValueIsValid(false);
    setHasError(false);
  };

  return {
    currentValue,
    isValid: valueIsValid,
    hasError,
    onChangeHandler,
    onEnterHandler,
    inputReset,
  };
};

export default useInput;
